import { Modal, Box, Container, Typography, Button, Card, CardContent, CardMedia, Grid, Tooltip, IconButton } from "@mui/material";
import { Block, BlockType } from "../new";
import { FC, useEffect, useState } from "react";
import SelectMulti, { IOption } from "../../../components/globalComponents/select";
import { TagService } from "../../../services/tags";
import { PostService } from "../../../services/post";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { category } from "../../../enum/category";
import TagPopover from "./newTag";

export const ModalConfirm: FC<{
    open: boolean, 
    setOpen(value: boolean): void, 
    list: Block[],
    title: string,
    preview: string,
}> = ({open, setOpen, list, title, preview}) => {
    
    const handleClose = () => setOpen(false);
  
    return (
  
      <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
      <Box sx={style}>
          <ContentConfirm list={list} title={title} preview={preview}/>
      </Box>
      </Modal>
  
    );
  }



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#f3f3f3',
    borderRadius: "0.5em",
    boxShadow: 24,
    p: 2,
    maxHeight: "95vh",
    overflowY: "auto"
};

export const ContentConfirm: React.FC<{ list: Block[], title: string, preview: string}> = ({ list, title, preview }) => {

    const navigate = useNavigate();

    const instance = new PostService();
    const tag = new TagService();

    const [tags, setTags] = useState<IOption[]>([]);

    const [categorySelected, setCategorySelected] = useState<IOption | undefined | null>();
    const [tagsSelected, setTagsSelected] = useState<IOption[]>([]);

    const categories = [
        {
            label: category.BLOG,
            value: category.BLOG
        },
        {
            label: category.NOTICIA,
            value: category.NOTICIA
        },
    ]

    const getTags = () =>{
        tag.get()
        .then(res => setTags(res?.data?.map(item => ({value: item.id, label: item.name}))))
    }

    useEffect(() => {   
        getTags();
    }, []);

    const handleConfirm = () => {

        let formattedTitle = title
        .trim() // Remove espaços no início e fim
        .toLowerCase() // Converte para minúsculas
        .replace(/[^a-z0-9\s]/g, "") // Remove caracteres especiais
        .replace(/\s+/g, "-"); // Substitui espaços por "-"
        
        let formData = new FormData();
        formData.append("title", title.trim());
        formData.append("slug", formattedTitle);
        formData.append("preview", preview);

        if(categorySelected)
        formData.append("category", categorySelected.value);
        else return
        // adiciona cada bloco em lista no formdata
        list.forEach((block, index) => {
        formData.append(`blocks[${index}][type]`, block.type);
        formData.append(`blocks[${index}][content]`, block.content);
        
        if (block.imageFile) {
            // adiciona imageFile se existir
            formData.append(`blocks[${index}][imageFile]`, block.imageFile);
        } 
        });
        
        // adiciona cada tag no formdata
        tagsSelected.forEach((tag, index) => {
        formData.append(`tags[${index}]`, tag.label);
        });

        instance
        .post(formData)
        .then(data => {
            console.log('res', data);
            
            toast.success("Postado com sucesso!");
            navigate(`/blog/post/${data.slug}`)

        })
    }
    const [image, setImage] = useState<string | undefined>();

    useEffect(() => {
        setImage(list.find(item => item.type === BlockType.IMAGE)?.imageUrl);
    }, []);

    const renderPreview = () => {

        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
                <Typography>Visualização do Prevío</Typography>
                <Grid item xs={12} sm={6} md={4}>
                    <Card style={{ height: '100%' }}>
                    <CardMedia
                        component="img"
                        alt="Imagem do artigo 2"
                        style={{ aspectRatio: "4/3", height: "20em"}}
                        image={image}
                        title="Título do Artigo 2"
                    />
                    <CardContent>
                        <Typography variant="h6">{title}</Typography>
                        <Typography variant="body2" color="textSecondary" style={{ textWrap: "wrap"}}>
                        {preview}
                        </Typography>
                        <Box mt={2}>
                        <Button size="small" color="primary">Leia Mais</Button>
                        </Box>
                    </CardContent>
                    </Card>
                </Grid>
            </Box>
        )
    }
    return (
        <Container>
            <Typography variant="h5" sx={{ m: "0 auto"}}>{title}</Typography>
        
            <Box component="ul" sx={{ p: 0 }}>
                {
                    list.map((block, index) => {
                        if(block.type === BlockType.IMAGE)
                            return <img key={index}  style={{ width: "100%" }} src={block.imageUrl}/>
                        else
                        return (
                            <Box key={index} dangerouslySetInnerHTML={{ __html: block.content }} >
                            </Box>
                        )
                    })
                }
            </Box>
            <hr style={{ margin: "1em 0"}}/>
            <Box  display="flex" justifyContent="center">
                <Box display="flex">
                    <SelectMulti
                        disabled={false}
                        placeholder={'Selecione as  Tags'}
                        oldValues={tagsSelected}
                        options={tags}
                        onChange={newValues => setTagsSelected(newValues)}
                    />
                    <TagPopover update={getTags}/>
                </Box>
                <Select
                    placeholder="Selecione a categoria"
                    options={categories}
                    onChange={newValues => setCategorySelected(newValues)}
                />

            </Box>
            <hr style={{ margin: "1em 0"}}/>
            {
                renderPreview()
            }
            <Box sx={{display: "flex", justifyContent: "center", pt: "1em"}}>
                <Button color="warning" variant="contained" disabled={!(tagsSelected.length > 0)} onClick={handleConfirm}>
                    Confirmar
                </Button>
            </Box>
        </Container>
    )
}
